import { render } from "./ShareToClassColumn.vue?vue&type=template&id=29cadee2"
import script from "./ShareToClassColumn.vue?vue&type=script&lang=js"
export * from "./ShareToClassColumn.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__